(function () {
  function initEmbla(root) {
    if (!root || root.__emblaInitialized) return;

    const viewport = root.querySelector('.embla__viewport');
    if (!viewport || typeof EmblaCarousel !== 'function') return;

    const dotsRoot        = root.querySelector('.embla__dots');
    const loop            = (root.dataset.loop || 'true') === 'true';
    const draggable       = (root.dataset.draggable || 'true') === 'true';
    const autoplayEnabled = (root.dataset.autoplay || 'false') === 'true';
    const autoplayDelay   = Number(root.dataset.autoplayDelay || 4000);
    const prefersReduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prevButtonNode  = root.querySelector('.embla__prev');
    const nextButtonNode  = root.querySelector('.embla__next');

    let autoplayPlugin;
    if (autoplayEnabled && !prefersReduced && typeof EmblaCarouselAutoplay === 'function') {
      autoplayPlugin = EmblaCarouselAutoplay({
        delay: autoplayDelay,
        stopOnInteraction: true
      });
    }

    const embla = EmblaCarousel(
      viewport,
      {
        loop,
        draggable,
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1
      },
      autoplayPlugin ? [autoplayPlugin] : []
    );

    // Hover pause/resume (pass embla!)
    if (autoplayPlugin) {
      root.addEventListener('mouseenter', () => autoplayPlugin.stop(embla));
      root.addEventListener('mouseleave', () => autoplayPlugin.play(embla));
    }

    // ----- Dots -----
    let dots = [];

    function setupDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';

      // Create one dot per "snap" (slide position)
      embla.scrollSnapList().forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'embla__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsRoot.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateDots() {
      if (!dotsRoot || !dots.length) return;
      const selected = embla.selectedScrollSnap();
      dots.forEach((dot, i) => {
        const active = i === selected;
        dot.classList.toggle('is-selected', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    setupDots();
    updateDots();

    // Keep dots in sync when Embla changes state
    embla.on('select', updateDots);
    embla.on('reInit', () => { setupDots(); updateDots(); });

    // Prev/Next buttons
    if (prevButtonNode) prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
    if (nextButtonNode) nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);

    const toggleButtonsDisabled = (embla) => {
      const setButtonState = (button, enabled) => {
        if (!button) return
        button.toggleAttribute('disabled', !enabled)
      }
      setButtonState(prevButtonNode, embla.canScrollPrev())
      setButtonState(nextButtonNode, embla.canScrollNext())
    }

    toggleButtonsDisabled(embla)
    embla.on('select', toggleButtonsDisabled)
    embla.on('reInit', toggleButtonsDisabled)

    root.__emblaInitialized = true;
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.embla').forEach(initEmbla);
  });
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.embla');
    if (root) initEmbla(root);
  });

  // Some carousels (e.g. complementary products) are injected into the DOM
  // after page load via the Section Rendering API, so they miss the events
  // above. Watch for dynamically added `.embla` elements and initialize them.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('.embla')) initEmbla(node);
        node.querySelectorAll('.embla').forEach(initEmbla);
      });
    }
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();